module.exports = __webpack_public_path__ + "static/media/card.7dcc7761.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/card.wav
// module id = 507
// module chunks = 0